'use client';

import { AdminMenuIcon } from '@/components/icons';
import { useIsSAXUser } from '@/hooks/useIsSAXUser';
import NavIconLink from './NavIconLink';

export default function AdminDropdown() {
  const { data: hasSaxRole, isLoading } = useIsSAXUser();

  if (isLoading || !hasSaxRole) {
    return null;
  }

  return (
    <NavIconLink href="/admin" label="Admin">
      <AdminMenuIcon className="h-6 w-6" />
    </NavIconLink>
  );
}
